import { useRef, useState } from 'react';

export const useFileInput = ({ disabled, loading, onDrop, multiple }) => {
  const inputRef = useRef(null);
  const [isDragActive, setIsDragActive] = useState(false);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled || loading) return;

    if (e.type === 'dragenter' || e.type === 'dragover') {
      setIsDragActive(true);
    } else if (e.type === 'dragleave') {
      setIsDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);

    if (disabled || loading) return;

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const droppedFiles = Array.from(e.dataTransfer.files);
      if (onDrop) onDrop(multiple ? droppedFiles : [droppedFiles[0]]);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (disabled || loading) return;

    if (e.target.files && e.target.files[0]) {
      const selectedFiles = Array.from(e.target.files);
      if (onDrop) onDrop(multiple ? selectedFiles : [selectedFiles[0]]);
    }
  };

  const onButtonClick = () => {
    if (disabled || loading) return;
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  return {
    inputRef,
    isDragActive,
    handleDrag,
    handleDrop,
    handleChange,
    onButtonClick,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/FileInput/hooks/useFileInput.js